<template>
  <transition name="modal">
    <div class="modal-wrapper">
      <div class="modal-container error-modal">
        <button type="button" class="close" aria-label="Close"><span aria-hidden="true" @click="$emit('closeError')">&times;</span></button>
        <div class="row">
          <h2>Błąd</h2>
          <table class="table table-condensed table-hover">
            <tbody>
              <tr>
                <th>id</th>
                <td>{{errorSel.id}}</td>
              </tr>
              <tr>
                <th>Zwrotka</th>
                <td>{{errorSel.body}}</td>
              </tr>
              <tr>
                <th>Data</th>
                <td>{{errorSel.createdAt | formatDateTime}}</td>
              </tr>
              <tr>
                <th>Kod</th>
                <td>{{matrix.code}}</td>
              </tr>
              <tr>
                <th>Miejsce</th>
                <td>{{matrix.area}}</td>
              </tr>
              <tr>
                <th>Obiekt</th>
                <td>{{matrix.object}}</td>
              </tr>
              <tr>
                <th>Błąd</th>
                <td>{{matrix.error}}</td>
              </tr>
              <tr>
                <th>Opis</th>
                <td>{{matrix.description}}</td>
              </tr>
              <tr>
                <th>R</th>
                <td>{{matrix.R}}</td>
              </tr>
              <tr>
                <th>I</th>
                <td>{{matrix.I}}</td>
              </tr>
              <tr>
                <th>Poziom</th>
                <td>{{matrix.level}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'error-display',
  props: ['errorSel', 'matrix'],
  data () {
    return {
    }
  },
  methods: {
    escapeModal (e) {
      if (e.key === 'Escape') {
        this.$emit('closeError')
      }
    }
  },
  created () {
    window.addEventListener('keyup', this.escapeModal, false)
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.escapeModal, false)
  }
}
</script>
<style lang="sass" scoped>
th
  white-space: nowrap
  width: 5%

.error-modal
  position: absolute
  z-index: 999
  margin-top: -20px !important
  margin-left: -20px !important
</style>



// WEBPACK FOOTER //
// src/components/reports/Sales.vue